(function() {
    angular
        .module('emarket.main.post')
        .controller('FilterPanelController', ['$log', '$scope', 'mdPanelRef', 'Announcer', 'model', function($log, $scope, mdPanelRef, Announcer, model) {
            var vm = this;
            vm.fromPanel = true;

            var announcer = Announcer.create($scope);
            var updateModel = function(model) {
                Object.keys(model).forEach(function(key) {
                    if (!/^\$/.test(key)) {
                        vm[key] = model[key];
                    }
                });
            };
            updateModel(model);
            announcer.on(Announcer.types.FILTER_PANEL_UPDATE, function(ev, model) {
                updateModel(model);
            });
            announcer.on(Announcer.types.SEARCH_LOADING, function(ev, isLoading) {
                vm.isLoading = isLoading;
            });

            vm.close = function() {
                mdPanelRef.close();
            };
            vm.clearAndClose = function() {
                vm.clearFilters();
                vm.close();
            };
        }]);
}());
